/* eslint-disable no-shadow */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';

// Relative import
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { localStorageSet } from '../../service/localStorage';
import { createOrder, asyncUpload } from '../../api/order';
import {
  addUploadedOrderImage,
  setIsUploadedClientPhoto,
  updateOrderDetailInfoAction,
  setIsClickConfirmOrder,
} from '../../actions/order';
import s from '../../assets/styles/style.sass';
import s2 from './orderSummary.sass';

class OrderSummarySumbitButton extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    onClickConfirm: PropTypes.func.isRequired,
    setIsClickConfirmOrder: PropTypes.func.isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
    images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    addUploadedOrderImage: PropTypes.func.isRequired,
    isUploadedClientPhoto: PropTypes.bool.isRequired,
    setIsUploadedClientPhoto: PropTypes.func.isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    client_uploads: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isCreatingOrder: false,
    };
    this.onYes = this.onYes.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // if uploaded all client photo, create order
    if (this.props.isUploadedClientPhoto !== nextProps.isUploadedClientPhoto) {
      this.props.updateOrderDetailInfoAction(
        'client_uploads',
        null,
        this.props.client_uploads,
      );
      this.setState({ isCreatingOrder: true });
      const orderInfo = {
        ...this.props.orderDetailInfo,
        client_uploads: this.props.client_uploads,
      }
      createOrder(orderInfo, this.props.currentLocale)
        .then(result => {
          if (result.status === 200 || result.status === 204) {
            // go to order detail page
            result.json().then(order => {
              localStorageSet('current.order.id', order.order.id);
              // give time to input localStorage
              setTimeout(() => {
                window.location.href = '/show';
              }, 500);
            });
          } else {
            this.props.setIsUploadedClientPhoto(false);
            this.setState({ isCreatingOrder: false });
          }
        })
        .catch(error => {
          this.props.setIsUploadedClientPhoto(false);
          this.setState({ isCreatingOrder: false });
          return error;
        });
    }
  }

  onYes() {
    asyncUpload(
      this.props.images,
      this.props.currentLocale,
      this.props.addUploadedOrderImage,
      this.props.setIsUploadedClientPhoto,
    );
  }
  render() {
    return (
      <div>
        <Row>
          <Col md={{ size: '6', offset: 3 }} sm="12">
            <Button
              id="summary-find-driver"
              className={`${s.button} ${s.primary} ${s.globalTextBlue} ${
                s2.buttonFull
              }`}
              onClick={() => {
                this.onYes();
              }}
              disabled={this.state.isCreatingOrder}
            >
              {this.props.modelDataText.order_summary_order_confirm_button}
            </Button>
          </Col>
        </Row>
        <Row style={{ marginTop: '10px' }}>
          <Col md={{ size: '6', offset: 3 }} sm="12">
            <Button
              className={`${s.button} ${s.secondary} ${s.outlined} ${
                s2.buttonFull
              }`}
              onClick={() => {
                this.props.onClickConfirm();
                this.props.setIsClickConfirmOrder(false);
              }}
              disabled={this.state.isCreatingOrder}
            >
              {this.props.modelDataText.order_summary_order_edit_button}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapState = state => ({
  currentLocale: state.intl.locale,
  orderDetailInfo: state.order.orderDetailInfo,
  images: state.order.images,
  client_uploads: state.order.client_uploads,
  isUploadedClientPhoto: state.order.isUploadedClientPhoto,
});
const mapDispatch = {
  addUploadedOrderImage,
  setIsUploadedClientPhoto,
  updateOrderDetailInfoAction,
  setIsClickConfirmOrder,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(OrderSummarySumbitButton),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummarySumbitButton.js